import React, { FC } from 'react'
import { Skeleton } from 'transfix-ui/core'
import { LockedTooltip } from 'apps/fleet-planner/components/load-details/LockedTooltip'
import { Bullet } from 'components/atoms'
import formatCurrency from 'utils/formatCurrency'
import { DISPLAY } from 'constants/display'

interface IExternalRateProps {
  carrierRate?: string
  totalRate?: string
  carrierTotalAccessorialRate?: string
  isQuickpayEnabled?: boolean
  paymentTerms: string
  isLoading?: boolean
}

export const ExternalRate: FC<IExternalRateProps> = ({
  carrierRate,
  carrierTotalAccessorialRate,
  isLoading,
  isQuickpayEnabled,
  paymentTerms,
  totalRate,
}) => {
  return (
    <div className='inline-edit-container locked'>
      {isLoading ? (
        <Skeleton variant='rectangular' height={20} width={190} />
      ) : (
        <>
          <LockedTooltip className='locked-icon' />
          <div>{totalRate ? <>{formatCurrency(totalRate)} Total Rate</> : DISPLAY.empty}</div>
          <div className='text-secondary'>
            {carrierRate ? <>{formatCurrency(carrierRate)} Carrier Rate</> : DISPLAY.empty}
            <Bullet />
            {carrierTotalAccessorialRate ? (
              <>{formatCurrency(carrierTotalAccessorialRate)} Additional Payables</>
            ) : (
              'No additional payables'
            )}
          </div>
          <div className='text-secondary'>
            Payment Terms: {paymentTerms} days {isQuickpayEnabled && <>(Quick Pay)</>}
          </div>
        </>
      )}
    </div>
  )
}
